const HIDDEN_HIGHLIGHTS_STORAGE_KEY =
  'hidden-floating-notification-highlights'

function getSessionStorageKey(userId: number) {
  return `${HIDDEN_HIGHLIGHTS_STORAGE_KEY}:${userId}`
}

export function readHiddenNotificationHighlightIds(userId: number): number[] {
  try {
    const stored = window.sessionStorage.getItem(getSessionStorageKey(userId))
    const values: unknown = stored ? JSON.parse(stored) : []

    return Array.isArray(values)
      ? values.filter((value): value is number => Number.isInteger(value))
      : []
  } catch {
    return []
  }
}

export function saveHiddenNotificationHighlightIds(
  userId: number,
  notificationIds: number[]
) {
  window.sessionStorage.setItem(
    getSessionStorageKey(userId),
    JSON.stringify(notificationIds)
  )
}

export function clearHiddenNotificationHighlightIds(userId: number) {
  window.sessionStorage.removeItem(getSessionStorageKey(userId))
}
